import { fabFacebookF } from 'shared/@generated/icons/fabFacebookF';
import { fabLinkedinIn } from 'shared/@generated/icons/fabLinkedinIn';
import { fasEnvelope } from 'shared/@generated/icons/fasEnvelope';
import { Text } from 'shared/components/text';
import { View } from 'react-native';
import { Image } from 'shared/components/image';
import { useTranslation } from 'react-i18next';
import { Link } from 'shared/components/link';
import { Icon } from 'shared/components/icon';
import { staticImage } from 'shared/library/static-images';
import type { MediaImageSource } from 'shared/library/media-image-versions';

interface AuthorCardProps {
  author: 'andre';
  dense?: boolean;
}

interface Author {
  image: MediaImageSource;
  name: string;
  role: string;
  description: string;
  email: string;
  linkedIn?: string;
  facebook?: string;
}

export const AuthorCard = ({ author, dense = false }: AuthorCardProps) => {
  const { t } = useTranslation('components');

  const authors: Record<AuthorCardProps['author'], Author> = {
    andre: {
      image: staticImage('andre'),
      name: 'André Andersson',
      role: t('author_card.role'),
      description: t('author_card.description'),
      email: 'andre@skaffahund.se',
      linkedIn: 'https://linkedin.com/in/anderssonandre',
      facebook: 'https://facebook.com/andreandersson01',
    },
  };

  const { image, name, role, description, email, linkedIn, facebook } = authors[author];

  return (
    <View
      className={`border-brand-brown-dark/20 max-w-prose rounded border bg-white ${dense ? 'flex-row items-center gap-3 p-3 md:self-start' : 'gap-6 p-3 md:flex-row md:items-start md:p-6'}`}
    >
      <Image
        src={image}
        alt={name}
        containerClassName={dense ? 'size-14' : 'size-32 md:size-40'}
        imageClassName={`object-cover ${dense ? 'rounded-lg' : 'rounded-lg'}`}
        sizeType={'avatar'}
      />

      <View className={'flex-1'}>
        <Text className={`text-brand-brown-dark/70 ${dense ? 'text-sm' : 'text-sm md:text-base'}`}>
          {role}
        </Text>
        <Text
          className={`text-brand-brown-dark ${dense ? 'font-black' : 'mt-1 text-xl font-bold md:text-2xl'}`}
        >
          {name}
        </Text>

        {!dense && (
          <>
            <Text className={'text-brand-brown-dark mt-3'}>{description}</Text>

            <View className={'mt-3 flex-row items-center gap-3'}>
              {email && (
                <Link href={`mailto:${email}`} openInNewTab={true}>
                  <View
                    className={
                      'bg-brand-brown-dark flex size-10 items-center justify-center rounded-full hover:opacity-80'
                    }
                  >
                    <Icon icon={fasEnvelope} className={'size-5 text-white'} />
                  </View>
                </Link>
              )}

              {linkedIn && (
                <Link href={linkedIn} openInNewTab={true}>
                  <View
                    className={
                      'flex size-10 items-center justify-center rounded-full bg-[#0077B5] hover:opacity-80'
                    }
                  >
                    <Icon icon={fabLinkedinIn} className={'size-5 text-white'} />
                  </View>
                </Link>
              )}

              {facebook && (
                <Link href={facebook} openInNewTab={true}>
                  <View
                    className={
                      'flex size-10 items-center justify-center rounded-full bg-[#1877F2] hover:opacity-80'
                    }
                  >
                    <Icon icon={fabFacebookF} className={'size-5 text-white'} />
                  </View>
                </Link>
              )}
            </View>
          </>
        )}
      </View>
    </View>
  );
};
